// extracted by mini-css-extract-plugin
export var cardLayout = "_7v-1";
export var paginationContainer = "_7v-0";